






















































































import Vue from 'vue';
import RecipientService from '@/services/recipient/recipient-service';

export default Vue.extend({
  props: {
    recipients: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    recipientService: new RecipientService(),
  }),
  methods: {
    resetRecipient(recipient) {
      this.recipientService.reset(recipient).then(() => {
        this.$emit('recipientReset', recipient);
      }, (error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },
  },
});
